goog.provide("shadow.js.shim.module$src$svg$wpp$content$hub_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$hub_svg");
shadow.js.shim.module$src$svg$wpp$content$hub_svg = shadow.js.nativeProvides["src/svg/wpp/content/hub.svg"] = shadow$bridge("src/svg/wpp/content/hub.svg");
module$shadow_js_shim_module$src$svg$wpp$content$hub_svg.default = shadow.js.shim.module$src$svg$wpp$content$hub_svg;
